export const ADD_CONTACT = 'ADD_CONTACT';
export const ADD_CONTACTS = 'ADD_CONTACTS';
export const REMOVE_CONTACT = 'REMOVE_CONTACT';
export const EDIT_CONTACT = 'EDIT_CONTACT';
export const SET_CONTACTS = 'SET_CONTACTS';
export const RESET_CONTACTS = 'RESET_CONTACTS';

export function addContact(value) {
  return {
    type: ADD_CONTACT,
    value,
  };
}

export function addContacts(value) {
  return {
    type: ADD_CONTACTS,
    value,
  };
}

export function removeContact(contactId) {
  return {
    type: REMOVE_CONTACT,
    contactId,
  };
}

export function editContact(value) {
  return {
    type: EDIT_CONTACT,
    value,
  };
}

export function setContacts(value) {
  return {
    type: SET_CONTACTS,
    value,
  };
}

export function resetContacts() {
  return {
    type: RESET_CONTACTS,
  };
}
